import React from 'react';


const TableRowSolicitudes = (props) => {
    const { cuenta, permisoModificacion, permisoBaja } = props;
    
    let CuentaTarjetaNumero = props.cuenta.CuentaTarjetaNumero;
    let estado = cuenta.estadoId ? cuenta.estadoId : cuenta.estado;
    let administradora = cuenta.marcaId;
    let bold = false
    let logo = " image-visa-logo"
    let estadoAMostrar
    let claseEstado = null
    let claseTipoCuenta = ""
    let mostrarEditar = true
    let mostrarEliminar = true
    let listadoTarjetas = ""
    let limite = ""

    let sucursal = ""


    //EL LIMITE PUEDE VENIR EN FORMATO STRING CON DECIMALES (PARA LAS CUENTAS) O COMO INT(PARA LAS EMPRESAS), NINGUNA DE LAS DOS SIRVEN, POR LO QUE SE PARSEA AL FORMATO NECESARIO
    if (cuenta.tipoProducto == "TP")
        limite = "";
    else if (cuenta.limite) {
        let limiteString = parseInt(cuenta.limite);
        limiteString = limiteString.toString();
        limite += limiteString.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    }

    //SE CONSTRUYE EL STRING DE SUCURSAL PARA CUENTAS
    if (cuenta.sucursalDescripcion) {
        sucursal += cuenta.sucursalSeleccionadaId + " - " + cuenta.sucursalDescripcion;
    }


    if (cuenta.Tarjetas && cuenta.Tarjetas.length > 0) {
        //SI HAY TARJETAS SE ORDENAN ALFABÉTICAMENTE EN UN NUEVO ARREGLO Y SE USA EL MISMO PARA CONSTRUIR UN STRING PARA EL TOOLTIP DE "INTEGRANTES"
        let arrTarjetasOrdenado = []
        cuenta.Tarjetas.map(t => arrTarjetasOrdenado.push(t.Apellido + ", " + t.Nombre));
        arrTarjetasOrdenado.sort()
        arrTarjetasOrdenado.map(tarjeta => {
            listadoTarjetas += "- " + tarjeta + "\n"
        })
    }

    //SE UBICA EL TOOLTIP DE ESTADO AL PIE DEL MISMO
    $(function () {
        $('[data-toggle="tooltip"]').tooltip({
            placement: 'bottom'
        });
    });

    switch (administradora) {
        case 1:
            logo = " image-visa-logo"
            break;

        case 2:
            logo = " image-cabal-logo"
            break;

        case 3:
            logo = " image-mastercard-logo"
            break;
    }

    claseTipoCuenta = " icon-cuentas";

    mostrarEditar = estado == 3 ? true : false;
    mostrarEliminar = estado == 3 ? true : false;


    switch (estado) {
        case 1:
            estadoAMostrar = "Solicitada"
            claseEstado = " etiquetaCeleste"
            break;
        case 2:
            estadoAMostrar = "Operativa"
            claseEstado = " etiquetaCeleste"
            break;
        case 3:
            estadoAMostrar = "Operativa"
            claseEstado = " etiquetaCeleste"
            break;
        case 4:
            estadoAMostrar = "Inhabilitada"
            claseEstado = " etiquetaCeleste"
            break;
        case 6:
            estadoAMostrar = "Dada de baja"
            claseEstado = " etiquetaCeleste"
            break;
        case 7:
            estadoAMostrar = "En proc.de baja"
            claseEstado = " etiquetaCeleste"
            break;
        case 8:
            estadoAMostrar = "Rechazada"
            claseEstado = " etiquetaCeleste"
            break;
    }

    if (!permisoModificacion) {
        mostrarEditar = false;
    }

    if (!permisoBaja) {
        mostrarEliminar = false;
    }


    if (props.rowS != "") {
        return (
            <tr className="rowBordersVistaCliente">
                <td rowSpan={props.rowS} className="rowBordersVistaCliente" style={{ verticalAlign: "middle", textAlign: "center" }}>
                    <label style={{ marginTop: administradora == 2 ? "-10px" : "10px", marginBottom: administradora == 2 ? "-10px" : "5px" }} className={"rowTextVistaCliente" + logo}></label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label className={"rowTextVistaCliente tdSolicitudes" + claseTipoCuenta}></label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label onClick={() => props.AbrirModuloConsultaOperacionCuenta(cuenta)} style={{ fontWeight: bold ? "bold" : "normal" }} className="rowTextVistaCliente tdSolicitudes clickable">{CuentaTarjetaNumero}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label style={{ fontWeight: bold ? "bold" : "normal" }} className="rowTextVistaCliente tdSolicitudes">{cuenta.tipoCuentaEmpresDescricpion ? cuenta.tipoCuentaEmpresDescricpion : cuenta.tipoCuentaDescripcion}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label className={"rowTextVistaCliente tdSolicitudes" + claseEstado}>{estadoAMostrar}</label>
                </td>
                <td style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label style={{ fontWeight: bold ? "bold" : "normal" }} className="rowTextVistaCliente tdSolicitudes"></label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label style={{ fontWeight: bold ? "bold" : "normal" }} className="rowTextVistaCliente tdSolicitudes">{sucursal}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label data-html="true" data-toggle="tooltip" data-placement="bottom" title={listadoTarjetas} className="rowTextVistaCliente white-tooltip conSaltoLinea" style={{ color: "#00a5ff", marginTop: "0px", marginBottom: "0px" }}>{cuenta.Tarjetas && cuenta.Tarjetas.length + " TJ"}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    {mostrarEditar && <label onClick={() => props.seleccionarComponente(2, cuenta)} style={{ marginTop: "0px", marginBottom: "0px", marginRight: "5px", cursor: "pointer" }} className="rowTextVistaCliente icon-editar"></label>}
                    {mostrarEliminar && <label onClick={() => props.eliminarCuenta(cuenta)} style={{ marginTop: "0px", marginBottom: "0px", marginRight: "5px", cursor: "pointer" }} className="rowTextVistaCliente icon-eliminar"></label>}
                </td>
            </tr>
        );
    } else {
        return (
            <tr className="rowBordersVistaCliente">
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label className={"rowTextVistaCliente tdSolicitudes" + claseTipoCuenta}></label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label onClick={() => props.AbrirModuloConsultaOperacionCuenta(cuenta)} style={{ fontWeight: bold ? "bold" : "normal" }} className="rowTextVistaCliente tdSolicitudes">{CuentaTarjetaNumero}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label style={{ fontWeight: bold ? "bold" : "normal" }} className="rowTextVistaCliente tdSolicitudes">{cuenta.tipoCuentaEmpresDescricpion ? cuenta.tipoCuentaEmpresDescricpion : cuenta.tipoCuentaDescripcion}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label className={"rowTextVistaCliente tdSolicitudes" + claseEstado}>{estadoAMostrar}</label>
                </td>
                <td style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label style={{ fontWeight: bold ? "bold" : "normal" }} className="rowTextVistaCliente tdSolicitudes"></label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label style={{ fontWeight: bold ? "bold" : "normal" }} className="rowTextVistaCliente tdSolicitudes">{sucursal}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    <label data-html="true" data-toggle="tooltip" data-placement="bottom" title={listadoTarjetas} className="rowTextVistaCliente white-tooltip conSaltoLinea" style={{ color: "#00a5ff", marginTop: "0px", marginBottom: "0px" }}>{cuenta.Tarjetas && cuenta.Tarjetas.length + " TJ"}</label>
                </td>
                <td className="rowBordersVistaClienteNoSides" style={{ backgroundColor: bold ? "#ebebeb" : "" }}>
                    {mostrarEditar && <label onClick={() => props.seleccionarComponente(2, cuenta)} style={{ marginTop: "0px", marginBottom: "0px", marginRight: "5px", cursor: "pointer" }} className="rowTextVistaCliente icon-editar"></label>}
                    {mostrarEliminar && <label onClick={() => props.eliminarCuenta(cuenta)} style={{ marginTop: "0px", marginBottom: "0px", marginRight: "5px", cursor: "pointer" }} className="rowTextVistaCliente icon-eliminar"></label>}
                </td>
            </tr>
        );
    }
}

export default TableRowSolicitudes;